module.exports = __webpack_public_path__ + "img/grid_purple.86109f42.png";